import React from 'react';
import { StarIcon } from 'lucide-react';
type StarsProps = {
  className?: string;
  size?: number;
};
export function Stars({
  className = 'text-catracho',
  size = 16
}: StarsProps) {
  return <span className={`inline-flex items-center gap-1 ${className}`} aria-hidden="true" data-id="element-326" data-mp="3kpn386vj77sx">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} size={size} fill="currentColor" strokeWidth={0} data-id="element-327" data-mp="3pqsus1dggp0v" data-mpi={i} />)}
    </span>;
}